import TableBoxCollection from '@widesk-ui/components/tableBox/TableBoxCollection';
import ApiModel           from '@widesk-core/models/ApiModel';
import React              from 'react';
import By                 from '@widesk-ui/components/By';
import ApiCollection      from '@widesk-core/models/ApiCollection';
import TableStore         from '@widesk-ui/stores/TableStore';

type StatusHistoryTableBoxProps<M extends typeof ApiModel> = TableBoxCollCompProps<M> & {
	modelClass: M;
	title?: string | false;
	renderRightColumn: (m: InstanceType<M>) => React.ReactNode;
	onFetchCollectionStart: (coll: ApiCollection<InstanceType<M>>) => Promise<unknown | boolean>;
};

const StatusHistoryTableBoxInner = function <M extends typeof ApiModel>(props: StatusHistoryTableBoxProps<M>, ref?: React.ForwardedRef<TableStore>) {
	const modelClass = props.modelClass as any;

	return (
		<TableBoxCollection
			bordered={false}
			inner
			title={props.title || modelClass.localize()}
			ref={ref}
			modelClass={modelClass}
			onFetchCollectionStart={props.onFetchCollectionStart}
			columns={[
				{
					render: m => <By model={m} />,
					title: '',
				},
				{
					render: props.renderRightColumn,
					align: 'right',
					title: '',
				},
			]}
			headerHidden
			defaultSortName="id"
			defaultSortWay="desc"

			{...props.options}
		/>
	);
};

const StatusHistoryTableBox = React.forwardRef(StatusHistoryTableBoxInner) as <M extends typeof ApiModel>(
	props: StatusHistoryTableBoxProps<M> & { ref?: React.ForwardedRef<TableStore> },
) => ReturnType<typeof StatusHistoryTableBoxInner>;

export default StatusHistoryTableBox;